import React from "react";
// import { useNavigate } from "react-router-dom";
import "../../styles/info/InfoFromBackground.css";
import ParliamentTabs from "../../components/info/ParliamentTabs";

const InfoFromBackground = () => {
  // const navigate = useNavigate();

  return (
    <div className="info-page">
      <ParliamentTabs />
      {/* <div className="info-header">
        <h1>What Can We Learn From Background Information?</h1>
        <p>
          Understanding the background of the voting system, politicians, and
          laws helps you make informed decisions. Here's what you need to know.
        </p>
      </div>

      <div className="info-section">
        <h2>1. How Voting Works</h2>
        <p>
          Australia uses a preferential voting system for the House of
          Representatives and proportional representation for the Senate.
        </p>
      </div>

      <div className="info-section">
        <h2>2. Role of Politicians</h2>
        <p>
          MPs represent your views in Parliament. Their voting record and
          speeches can show whether they align with your values.
        </p>
      </div>

      <div className="info-section">
        <h2>3. Sources You Can Trust</h2>
        <ul>
          <li>Official Parliament websites</li>
          <li>Hansard transcripts</li>
          <li>Voting history databases</li>
        </ul>
      </div> */}
    </div>
  );
};

export default InfoFromBackground;
